import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {map, Observable, of, tap} from 'rxjs';
import {Utils} from "../../shared/utils/generics.utils";
import {StoreService} from "../../shared/services/store.service";
import {Company} from "../models/company";
import {getSupportedLanguage, UiUtils} from "../../shared/utils/ui.utils";
import {ExternalApiService} from "../api/external-api/external-api.service";

export const CompanyResolver: ResolveFn<Company> = (): Observable<Company> => {

  const externalApiService = inject(ExternalApiService);
  const store = inject(StoreService);

  return companyResolverFn(externalApiService, store);
};

export const companyResolverFn = (externalApiService: ExternalApiService, store: StoreService) => {
  const storedCompany = store.getCompany();
  return storedCompany ? of(storedCompany) : externalApiService.getCompany(Utils.getCompanyFromDomain(), getSupportedLanguage()).pipe(
    map((dto) => new Company(dto)),
    tap((company) => {
      store.setCompany(company);
      return company;
    }));
}
